import Cookies from 'js-cookie';
import type { CookieKeyEnum } from './model/const';
import { defaultCookieAttributes } from './model/const';
import type { CookieHelper, CookieRecord } from './model/types';

const cookieApi = Cookies.withAttributes(defaultCookieAttributes);

export const cookieHelper: CookieHelper = {
    attributes: cookieApi.attributes,
    converter: cookieApi.converter,

    set: (name, value, options) => cookieApi.set(name, JSON.stringify(value), options),

    get: <K extends CookieKeyEnum>(name: K) => {
        const value = cookieApi.get(name);
        if (value === 'undefined') return;
        return value ? JSON.parse(value) as CookieRecord[K] : undefined;
    },

    update(name, value, options) {
        const prevValue = this.get(name);
        if (typeof prevValue !== 'object' || typeof value !== 'object') {
            this.set(name, value);
            return;
        }
        const newValue = prevValue ? { ...prevValue, ...value } : value;
        this.set(name, newValue, options);
    },

    getAll: () => cookieApi.get() as unknown as CookieRecord,

    remove: (name: CookieKeyEnum, options) => {
        cookieApi.remove(name, options);
    },
};
